import { useState, useEffect } from "react";
import AffiliateCampaignInvite from "./AffiliateCampaignInvite";
import { getData, postData } from "../../../global/Globalapi";
import { showAlert } from "../../DynamicComp/Alert";
import { storeEncodedLead } from '../../../global/Globalfunction';
function AffiliateCampaign() {
  const [formData, setFormData] = useState({
    campaign_name: "",
    target_url: "",
    campaign_description: "",
    commission: "",
  });
//   const detectUrlType = (url) => {
//   if (url.includes("/product/")) return "product";
//   if (url.includes("/shopping")) return "shopping";
//   return null;
// };

//   const extractProductId = (url) => {
//   try {
//     const parts = url.split("/");
//     const last = parts.pop();      // OA==
//     return atob(last);             // decode → "8"
//   } catch {
//     return null;
//   }
// };
// const extractIdFromShopping = (url) => {
//   try {
//     const params = new URL(url).searchParams;
//     const encoded = params.get("product");  // Nw==
//     return atob(encoded); // 7
//   } catch {
//     return null;
//   }
// };

// const storeEncodedLead = async (c) => {
//   try {
//     const userId = localStorage.getItem("usertypeid");
// // const productIdFromURL = extractProductId(c.target_url);
//  const urlType = detectUrlType(c.target_url);

//     let finalProductId = null;
//     let finalCategoryId = null;

//     if (urlType === "product") {
//       finalProductId = extractProductId(c.target_url);
//     }

//     if (urlType === "shopping") {
//       finalCategoryId = extractIdFromShopping(c.target_url);
//     }
//     const payload = {
//       user_id: btoa(String(userId)),                     // encoded
//       campaign_id: btoa(String(c.campaign_id)),          // encoded
//       // product_id: btoa(String(c.product_id || 0)),       // encoded
//       // product_id: btoa(String(productIdFromURL || 0)),
//       product_id: finalProductId ? btoa(String(finalProductId)) : null,
//       category_id: finalCategoryId ? btoa(String(finalCategoryId)) : null,
//       affiliated_campaign_id: btoa(String(c.affiliated_campaign_id || "")),
//       // category_id: null
//     };

//     await fetch("http://localhost:5000/api/campaign_leads", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(payload)
//     });

//     console.log("Encoded lead stored successfully");

//   } catch (error) {
//     console.error("Error storing encoded lead:", error);
//   }
// };

// const storeEncodedLead = async (c) => {
//   try {
//     const userId = localStorage.getItem("usertypeid");

//     const urlType = detectUrlType(c.target_url);

//     let finalProductId = null;
//     let finalCategoryId = null;

//     if (urlType === "product") {
//       finalProductId = extractProductId(c.target_url);
//     }

//     if (urlType === "shopping") {
//       finalCategoryId = extractIdFromShopping(c.target_url);
//     }

//     const payload = {
//        user_id: btoa(String(userId)), 
//       product_id: finalProductId ? btoa(String(finalProductId)) : null,
//       category_id: finalCategoryId ? btoa(String(finalCategoryId)) : null,
//       campaign_id: btoa(String(c.campaign_id)),
//       // affiliate_user_id: btoa(String(c.affiliate_user_id)),
//       affiliated_campaign_id: btoa(String(c.affiliated_campaign_id)),
//       from: urlType,           // 🔥 IMPORTANT FIX
//     };

//     await fetch("http://localhost:5000/api/store-lead", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(payload),
//     });

//     console.log("Lead stored successfully");
//   } catch (error) {
//     console.error("Error storing lead:", error);
//   }
// };

  const [errors, setErrors] = useState({});
  const [campaigns, setCampaigns] = useState([]);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [selectedCampaigns, setSelectedCampaigns] = useState([]); // ACTIVE campaigns
  const [showPopup, setShowPopup] = useState(false);
  const [copiedCampaignId, setCopiedCampaignId] = useState(null);
const [activated, setActivated] = useState(false);
const [campaignStats, setCampaignStats] = useState({});

  


  const affiliateId = Number(localStorage.getItem("usertypeid")); // Logged affiliate user

  // --------------------------------------------
  // 1️⃣ FETCH LIST OF ALL CAMPAIGNS
  // --------------------------------------------
  useEffect(() => {
    getData(`/affiliate/list/${affiliateId}`)
      .then((res) => {
        setCampaigns(res.data);
      })
      .catch((err) => console.error("Error fetching campaigns:", err));
  }, []);

  // --------------------------------------------
  // 2️⃣ LOAD ACTIVE CAMPAIGNS FOR THIS USER (ON REFRESH)
  // --------------------------------------------
  useEffect(() => {
    getData(`/affiliateCampaign/joined/${affiliateId}`)
      .then((res) => res.data)
      .then((list) => {
        // Extract only campaign_id
        const activeIds = list.map((row) => Number(row.campaign_id));
        console.log("Activated campaign IDs:", activeIds);
        setSelectedCampaigns(activeIds);
      })
      .catch((err) =>
        console.error("Error loading activated campaigns:", err)
      );
  }, []);

  // --------------------------------------------
  // 3️⃣ HANDLE SELECT: INSERT INTO DB + OPEN POPUP
  // --------------------------------------------
  const handleSelect = async (item) => {
    try {
      const payload = {
        affiliate_user_id: affiliateId,
        campaign_id: Number(item.campaign_id),
      };

      const res = await postData("/affiliateCampaign/join", payload);

      const data = res.data;

      setSelectedCampaign({
        ...item,
        affiliate_user_id: data.affiliate_user_id,
        affiliated_campaign_id: data.affiliated_campaign_id,
      });
 reloadActivatedCampaigns();
      setShowPopup(true); // Show popup
    } catch (error) {
      console.error("Join error:", error);
    }
  };
// const handleSelect = async (item) => {
//   try {
//     const res = await postData("/affiliateCampaign/join", {
//       affiliate_user_id: affiliateId,
//       campaign_id: Number(item.campaign_id),
//     });

//     setSelectedCampaign({
//       ...item,
//       affiliate_user_id: res.data.affiliate_user_id,
//       affiliated_campaign_id: res.data.affiliated_campaign_id,
//     });

//     reloadActivatedCampaigns();   // 🔥 instant update

//     setShowPopup(true);
//   } catch (error) {
//     console.error("Join error:", error);
//   }
// };
// const checkActivated = async () => {
//   try {
//     const res = await getData(`/affiliateCampaign/check?campaign_id=${campaign_id}&affiliate_user_id=${affiliate_user_id}`);

//     if (res.active === true) {
//       setActivated(true);  // show Activated in UI
//     }
//   } catch (e) {
//     console.log("Activation check failed:", e);
//   }
// };
// useEffect(() => {
//   checkActivated();
// }, []);

  // --------------------------------------------
  // 4️⃣ WHEN POPUP CLOSES → MARK AS ACTIVATED
  // --------------------------------------------
  // const handleClosePopup = () => {
  //   if (selectedCampaign) {
  //     const cid = Number(selectedCampaign.campaign_id);

  //     setSelectedCampaigns((prev) =>
  //       prev.includes(cid) ? prev : [...prev, cid]
  //     );
  //   }

  //   setSelectedCampaign(null);
  //   setShowPopup(false);
  // };
  const reloadActivatedCampaigns = async () => {
  try {
    const res = await getData(`/affiliateCampaign/joined/${affiliateId}`);
    const activeIds = res.data.map(row => Number(row.campaign_id));

    setSelectedCampaigns(activeIds);
  } catch (err) {
    console.error("Error refreshing activated list:", err);
  }
};

// --- paste this in place of your current fetchStats and the useEffect that calls /affiliateCampaign/joined ---
const fetchStats = async (campaign_id) => {
  try {
    const res = await getData(`/stats/${campaign_id}`);
    return res.data || { clicks: 0, conversions: 0 };
  } catch (err) {
    console.error("Stats fetch failed", err);
    return { clicks: 0, conversions: 0 };
  }
};



useEffect(() => {
  let mounted = true;

  const loadJoinedAndStats = async () => {
    try {
      const res = await getData(`/affiliateCampaign/joined/${affiliateId}`);
      const list = res.data || [];

      console.log("joined list:", list);

      // mark activated campaigns
      const activeIds = list.map((row) => Number(row.campaign_id));
      if (mounted) setSelectedCampaigns(activeIds);

      // fetch stats (collect promises)
      const statsObj = {};
      // fetch in parallel for better performance but map results back to campaign_id
 const fetchPromises = list.map(async (row) => {
  console.log("joined row:", row);

  // Always fetch stats using campaign_id
  const stats = await fetchStats(row.campaign_id);

  // SAVE STATS INTO OBJECT 🔥🔥🔥 (this fixes the issue!)
  statsObj[row.campaign_id] = {
    clicks: stats.clicks ?? 0,
    conversions: stats.conversions ?? 0,
  };
});


      await Promise.all(fetchPromises);

      if (mounted) {
        console.log("all stats loaded:", statsObj);
        setCampaignStats(statsObj);
      }
    } catch (err) {
      console.error("Error loading activated campaigns and stats:", err);
    }
  };

  loadJoinedAndStats();

  return () => {
    mounted = false;
  };
}, [affiliateId]); // reload when affiliateId changes


const handleClosePopup = () => {
  reloadActivatedCampaigns();  // 🔥 auto refresh activated list

  setSelectedCampaign(null);
  setShowPopup(false);
};

  // --------------------------------------------
  // FORM SUBMIT FOR CUSTOM CAMPAIGN
  // --------------------------------------------
  const handleSubmit = async (e) => {
    e.preventDefault();

    let newErrors = {};
    const required = [
      "campaign_name",
      "target_url",
      "campaign_description",
    ];

    required.forEach((f) => {
      if (!formData[f].trim()) {
        newErrors[f] = `Enter ${f.replace("_", " ")}`;
      }
    });

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      await postData("/affiliate/add-campaign", formData);

      showAlert({
        type: "success",
        title: "Campaign Submitted",
        message: "Your campaign will be reviewed.",
        duration: 2500,
      });

      setFormData({
        campaign_name: "",
        target_url: "",
        campaign_description: "",
      });
    } catch (err) {
      console.error(err);
      alert("❌ Server Error");
    }
  };

  // --------------------------------------------
  // JSX RETURN
  // --------------------------------------------
  return (
    <div className="container my-5">

      {/* ======== ACTIVE CAMPAIGNS TABLE ======== */}
      <div className=" card shadow-sm p-3 mb-4">
          <div className="d-flex">
            <h4 className="fw-bold mb-3">Active Campaigns</h4>
            <a href="#" className="text-primary fw-semibold ms-auto">
              View All Campaigns
            </a>
        </div>

        <table className="table table-hover">
          <thead>
            <tr>
              <th>CAMPAIGN</th>
              <th>COMMISSION</th>
              <th>CLICKS</th>
              <th>CONVERSIONS</th>
              <th>EARNINGS</th>
              <th>SESSION</th>
              <th>URL</th>
            </tr>
          </thead>
<tbody>
  {campaigns
    .filter(c => selectedCampaigns.includes(Number(c.campaign_id))) // only activated
    .map((c, index) => {

      const affiliateId = Number(localStorage.getItem("usertypeid"));

      // Base URL from DB
      const baseUrl = c.target_url || "";

      // Decide ? or &
      const separator = baseUrl.includes("?") ? "&" : "?";
      
      // Final URL
      // const generatedUrl = `${baseUrl}${separator}`+`campaign_id=${c.campaign_id}&`+`affiliate_user_id=${affiliateId}&`+`affiliated_campaign_id=${c.affiliated_campaign_id || ""}`;
      // const generatedUrl = `${target_url}?campaign_id=${campaign_id}&affiliate_user_id=${affiliateId}&affiliated_campaign_id=${affiliated_campaign_id}`;
     
const encodedCampaignId = btoa(String(c.campaign_id));
const encodedAffiliateId = btoa(String(affiliateId));
const encodedAffiliatedCampaignId = btoa(String(c.affiliated_campaign_id || ""));

const generatedUrl = `${baseUrl}${separator}campaign_id=${encodedCampaignId}&affiliate_user_id=${encodedAffiliateId}&affiliated_campaign_id=${encodedAffiliatedCampaignId}`;

console.log("Generated URL Debug →", {
  baseUrl,
  separator,
  campaign_id: c.campaign_id,
  affiliate_user_id: affiliateId,
  affiliated_campaign_id: c.affiliated_campaign_id || "",
  finalUrl: generatedUrl
});

      return (
        <tr key={index}>
          <td>
            <div className="d-flex align-items-center gap-3">
              <div
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: 10,
                  backgroundColor: "#eef3ff",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: 18,
                }}
              >
                📘
              </div>

              <div>
                <div className="fw-bold">{c.campaign_name}</div>
                <small className="text-muted">
                  {c.description || "No Description"}
                </small>
              </div>
            </div>
          </td>

          <td className="fw-bold">{c.commission || "0"}%</td>
         <td>{campaignStats[c.campaign_id]?.clicks ?? 0}</td>
<td>{campaignStats[c.campaign_id]?.conversions ?? 0}</td>

          <td className="fw-bold text-success">${c.earnings || 2847}</td>
          <td className="fw-bold text-success">{c.earnings || 0}</td>

          {/* URL Column */}
          <td>
            {/* <a
              href={generatedUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary fw-semibold"
              style={{ fontSize: "13px" }}
            >
              Open Link
            </a> */}
            <a
  href={generatedUrl}
  target="_blank"
  rel="noopener noreferrer"
  onClick={() => storeEncodedLead(c)}
>
  Open Link
</a>

            <br />

            {/* <small
              style={{ cursor: "pointer", color: "#555" }}
              onClick={() => {
                navigator.clipboard.writeText(generatedUrl);
                setCopiedCampaignId(c.campaign_id);

                setTimeout(() => setCopiedCampaignId(null), 2000);
              }}
            >
              📋 Copy
            </small> */}
            <small
  style={{ cursor: "pointer" }}
  onClick={() => {
    navigator.clipboard.writeText(generatedUrl);
    // storeEncodedLead(c);
    setCopiedCampaignId(c.campaign_id);
    setTimeout(() => setCopiedCampaignId(null), 2000);
  }}
>
  📋 Copy
</small>

            {copiedCampaignId === c.campaign_id && (
              <div style={{ color: "green", fontSize: "12px", marginTop: "4px" }}>
                ✔ Link Copied!
              </div>
            )}
          </td>
        </tr>
      );
    })}
</tbody>



        </table>
      </div>

      {/* ======== PREDEFINED CAMPAIGNS LIST ======== */}
      <div className="card shadow-lg p-4 mb-5">
        <h4 className="fw-bold">Start New Campaign</h4>
        <p className="text-muted mb-4">
          Choose predefined campaigns or create your own
        </p>

        <div className="row">
          {/* ✔ LEFT SIDE — PREDEFINED CAMPAIGNS */}
          <div className="col-md-6">
            {campaigns.map((item, i) => {
              const isActive = selectedCampaigns.includes(
                Number(item.campaign_id)
              );

              return (
                <div
                  key={i}
                  className="border p-3 rounded mb-3 d-flex justify-content-between align-items-center shadow-sm"
                >
                  <div>
                    <b>{item.campaign_name}</b>
                    <br />
                    <small className="text-muted">
                      Commission: {item.commission}% |
                      {item.description}
                    </small>
                  </div>

                  <button
                    onClick={() => handleSelect(item)}
                    className={`btn ${isActive ? "btn-success" : "btn-primary"}`}
                    disabled={isActive}
                  >
                    {isActive ? "Activated ✅" : "Select"}
                  </button>
                </div>
              );
            })}
           

          </div>

          {/* ✔ RIGHT SIDE — CUSTOM FORM */}
          <div className="col-md-6">
            <form onSubmit={handleSubmit}>
              <label className="fw-semibold">Campaign Name *</label>
              <input
                type="text"
                name="campaign_name"
                className="form-control mb-2"
                value={formData.campaign_name}
                onChange={(e) =>
                  setFormData({ ...formData, campaign_name: e.target.value })
                }
              />

              <label className="fw-semibold mt-2">Website URL *</label>
                   <input
                      type="url"
                      name="target_url"
                      className={`form-control mb-2 ${errors.target_url ? "is-invalid" : ""}`}
                      value={formData.target_url}
                      onChange={(e) => {
                        const value = e.target.value;
                        setFormData({ ...formData, target_url: value });

                        // ✅ Validate URL starts with "https://boltandbrook"
                        const pattern = /^https:\/\/boltandbrook/i;
                        if (value && !pattern.test(value)) {
                          setErrors({ ...errors, target_url: "URL must start with 'https://boltandbrook'" });
                        } else {
                          // remove only the target_url error, keeping others intact
                          const { target_url, ...rest } = errors;
                          setErrors(rest);
                        }
                      }}
                      placeholder="https://boltandbrook.com"
                  />
                <label className="fw-semibold">Commission *</label>
<input
  type="number"
  name="commission"
  className="form-control mb-2"
  value={formData.commission}
  onChange={(e) =>
    setFormData({ ...formData, commission: e.target.value })
  }
/>

              <label className="fw-semibold mt-2">Description *</label>
              <textarea
                className="form-control"
                name="campaign_description"
                rows="3"
                value={formData.campaign_description}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    campaign_description: e.target.value,
                  })
                }
              />

              <button className="btn btn-primary w-100 mt-3">
                Submit for Approval
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* ======== POPUP MODAL ======== */}
      {showPopup && selectedCampaign && (
        <div
          className="popup-overlay"
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 10000,
          }}
          onClick={() => setShowPopup(false)}
        >
          <div
            style={{
              width: "90%",
              maxWidth: "900px",
              background: "white",
              borderRadius: "8px",
              overflow: "hidden",
              padding: 0,
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <AffiliateCampaignInvite
              campaign={selectedCampaign}
              onClose={handleClosePopup}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default AffiliateCampaign;
